import {
  approveAllowance,
  approveContract,
  waitForOkenTransactionToEnd,
} from 'core/modules/firebase/service'
import {
  CustodyZeroXMarketplace,
  ExternalZeroXMarketplace,
} from './ZeroXMarketplace'
import BigNumber from 'bignumber.js'
import { normalizeUnitBN } from 'core/helpers/contract'
import ProgressDispatcher from 'openspace/service/Progress'
import { t } from 'translate/i18n'

export class CustodyEscrowMarketplace extends CustodyZeroXMarketplace {
  private getEscrowAddress() {
    return this.chainConfig.escrowAddress
  }
  async allowanceForCurrency(
    currency: string,
    _allowanceRequired: number
  ): Promise<number> {
    return this.isAllowanceAuthorized(
      currency,
      _allowanceRequired,
      this.getEscrowAddress()
    )
  }
  async setCurrencyAllowance(
    _currency: string,
    _allowThisMuch: number
  ): Promise<void> {
    const convertedToContractDecimals = normalizeUnitBN(
      BigNumber(_allowThisMuch).multipliedBy(100).toNumber(),
      this.currency[_currency].decimals
    )
    ProgressDispatcher.dispatchHandle(
      'step_approval',
      t('offer.buy.progress.authorizing'),
      0
    )
    const tx = await approveAllowance(
      _currency,
      this.galleries[0].id,
      this.getEscrowAddress(),
      convertedToContractDecimals.toFixed()
    )
    ProgressDispatcher.dispatchHandle(
      'step_approval',
      t('generic.waitingAuthorization'),
      1
    )
    await waitForOkenTransactionToEnd(tx)
  }
  async canMarketplaceManageTokens(
    tokenContract: Contract.ERC1155 | Contract.ERC721,
    tokenId?: number
  ): Promise<boolean> {
    return this.canOperatorManageTokens(
      tokenContract,
      this.getEscrowAddress(),
      tokenId
    )
  }
  async approveMarketplaceToManageTokens(
    galleryId: string,
    _tokenContract: string,
    tokenId?: number
  ): Promise<void> {
    ProgressDispatcher.dispatchHandle(
      'create_offer',
      t('offer.creation.steps.creating.progress.authorizing'),
      0
    )
    const tId = await approveContract(
      galleryId,
      this.getEscrowAddress(),
      true,
      tokenId
    )
    ProgressDispatcher.dispatchHandle(
      'create_offer',
      t('generic.waitingAuthorization'),
      1
    )
    await waitForOkenTransactionToEnd(tId)
  }
}

export class ExternalEscrowMarketplace extends ExternalZeroXMarketplace {
  async approveMarketplaceToManageTokens(
    _galleryId: string,
    _tokenContract: string
  ): Promise<void> {
    throw new Error('Not ready for external escrow yet')
  }
}
